<template>
    <div>
        <div>
            <div class="col-xs-12">
                <div class="description-block">
                    <p class="description-title"><span class="welcome-line">Herzlich Willkommen zur </span><br
                        class="text-break"><strong>CHECK24</strong> Mini <strong>CODING CHALLENGE</strong></p>
                </div>
            </div>
        </div>
        <div class="row flex-row" style="margin-bottom: 2rem;" v-if="this.$features.WHITELABEL">
            <div class="col-xs-12">
                <img
                    src="https://res.cloudinary.com/dspi5zyaa/image/upload/v1696252354/eh-platform/challenges/check24-banner.png"
                    class="banner-img"
                />
            </div>
        </div>
    </div>
</template>

<script>
import ChallengeOfTheWeek from "./campaigns/ChallengeOfTheWeek.vue";

export default {
    name: "WhiteLabelBannerComponent",
    components: {ChallengeOfTheWeek}
}
</script>

<style scoped>
.banner-img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    border-radius: 12px;
    margin-bottom: 2rem;
    object-position: left;
}

.description-block {
    font-size: 2.0rem;
    margin-bottom: 2rem;
}

.description-title {
    text-align: center;
}

@media (min-width: 576px) {
    .description-block {
        margin-top: 2rem;
        font-size: 3.7rem;
    }
}

.text-break {
    display: none;
}

@media (min-width: 576px) {
    .text-break {
        display: block;
    }
}

</style>